import { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { theme } from './theme';
import { AuthProvider } from './auth/AuthContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { SchedulePage } from './pages/SchedulePage';
import { ManageUsersPage } from './pages/ManageUsersPage';
import { NotFoundPage } from './pages/NotFoundPage';

// React Router doesn't scroll to an in-page #hash on navigation (only the browser's
// native anchor handling does, which only fires when you're already on that page).
// This re-does that scroll any time the route or hash changes.
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Navbar />
          <ScrollToHash />
          <Routes>
            <Route index element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/contact/:team" element={<ContactPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/manage-users" element={<ManageUsersPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
